module.exports = __webpack_public_path__ + "img/temperature.50a09def.svg";